import { render, staticRenderFns } from "./editSection.vue?vue&type=template&id=16fc610a&scoped=true&"
import script from "./editSection.vue?vue&type=script&lang=js&"
export * from "./editSection.vue?vue&type=script&lang=js&"
import style0 from "./editSection.vue?vue&type=style&index=0&id=16fc610a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fc610a",
  null
  
)

export default component.exports